<template>
  <div>
    <page-header :title="$t('license.config.title')" />
    <page-body class="page">
      <div class="flex w-full h-full">
        <div class="input">
          <div>
            <a-textarea :value="inputCode ?? ''" @change="handleInput" :placeholder="$t('license.config.input.placeholder')" :rows="10"
            class="h-4/6 mb-4" />
            <a-space direction="horizontal">
              <a-button type="primary" :disabled="!decodedContent || !edited" @click="handleSubmit">
                {{ $t('license.config.submit') }}
              </a-button>
            </a-space>
          </div>
        </div>
        <div class="w-1/2 p-4 mx-10">
          <a-empty v-if="!decodedContent" :description="$t('license.config.input.invalid')" />
          <div v-else>
            <!-- <LicenseDetail license="{decodedContent}" expired="{expired}" /> -->
            <license-config-detail :license="decodedContent" :expired="expired" />
          </div>
        </div>
      </div>
    </page-body>
  </div>
</template>

<script>
import LicenseConfigDetail from './licensedetail'
export default {
  name: 'LicenseConfig',
  components: {
    LicenseConfigDetail,
  },
  data () {
    return {
      inputCode: '',
      edited: false,
      expired: null,
    }
  },
  computed: {
    decodedContent () {
      return this.getDecodedContent()
    },
  },
  mounted () {
    this.getLicense().then(res => {
      if (res) {
        this.inputCode = res.content
        this.expired = res.expired
      }
    })
  },
  methods: {
    async updateLicense (content) {
      await this.$http({
        method: 'POST',
        url: '/v1/licenses',
        data: { content },
      })
    },
    async getLicense () {
      const { data } = await this.$http({
        method: 'GET',
        url: '/v1/licenses/latest',
      })
      return data
    },
    handleInput (e) {
      this.inputCode = e.target.value
      this.expired = null
      this.edited = true
    },
    getDecodedContent () {
      const trimed = this.inputCode.trim()
      if (!trimed) {
        return ''
      }
      try {
        const decoded = Buffer.from(trimed, 'base64').toString()
        return JSON.parse(decoded)
      } catch (error) {
        console.error(error)
        return ''
      }
    },
    handleSubmit () {
      const trimedInputCode = this.inputCode.trim()
      if (!trimedInputCode) {
        return
      }
      this.updateLicense(trimedInputCode)
        .then(() => {
          this.$message.success(this.$t('license.config.success'))
        })
        .catch(error => {
          console.error(error.response.data)
          // this.$message.error(error.response.data.details)
        })
    },
  },
}
</script>

<style>
.flex {
  display: flex;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

.input {
  width: 33.333333%;
  padding: 1rem;
}

.h-4\/6 {
  height: 66.666667%;
}

.mb-4 {
  margin-bottom: 1rem /* 16px */;
}

.w-1\/2 {
  width: 50%;
}

.p-4 {
  padding: 1rem /* 16px */;
}

.mx-10 {
  margin-left: 2.5rem /* 40px */;
  margin-right: 2.5rem /* 40px */;
}
</style>
